import CSDTable from "@cloudscape-design/components-themed/table";
import { Box, SpaceBetween } from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";
import { ApplicationStoreInfo, CSDict } from "../../features/api-interfaces";
import { formatDateTime } from "../../utils/format";

interface StoresTableProps {
  stores: ApplicationStoreInfo[];
  appStatusCodes: CSDict[];
  appDetailStatusCodes: CSDict[];
  isDocomoUser: boolean;
  isDocomoMasterUser: boolean;
  isFetching?: boolean;
}

/**
 * 申請内容照会 店舗情報タブ
 */
export const Table = (props: StoresTableProps) => {
  const convertValueToLabel = (value: string, codeList: CSDict[]) => {
    const convertResult = codeList
      .filter((code) => code.value === value)
      .map((code) => code.label);
    return convertResult.length === 0 ? "ー" : convertResult[0];
  };

  const convertValueToLabelNotMasterUser = (
    value: string,
    codeList: CSDict[]
  ) => {
    const convertResult = codeList
      .filter((code) => code.value === value && value === "01")
      .map((code) => code.label);
    return convertResult.length === 0 ? "ー" : convertResult[0];
  };

  const columnDefinitionsBase = [
    {
      id: "store_name",
      header: LABELS.STORE_NAME,
      cell: (e: any) => (e.name === null ? COMMON_LABELS.HYPHEN : e.name),
    },
    {
      id: "address",
      header: LABELS.ADDRESS,
      cell: (e: any) => (e.address === null ? COMMON_LABELS.HYPHEN : e.address),
    },
    {
      id: "updateDifferencial",
      header: LABELS.APPLICATION_TYPE,
      cell: (e: any) => e.updateDifferencial,
    },
    {
      id: "application_status",
      header: LABELS.APPLICATION_STATUS,
      cell: (e: any) =>
        convertValueToLabel(e.applicationStatusCode, props.appStatusCodes),
    },
    {
      id: "application_detail_status",
      header: LABELS.APPLICATION_DETAIL_STATUS,
      cell: (e: any) =>
        props.isDocomoMasterUser
          ? convertValueToLabel(
              e.applicationDetailStatusCode,
              props.appDetailStatusCodes
            )
          : convertValueToLabelNotMasterUser(
              e.applicationDetailStatusCode,
              props.appDetailStatusCodes
            ),
    },
    {
      id: "fixedTime",
      header: LABELS.ANSWER_START_TIME,
      cell: (e: any) =>
        e.fixedTime === null || e.fixedTime === ""
          ? COMMON_LABELS.HYPHEN
          : formatDateTime(e.fixedTime),
    },
    {
      id: "incompletionReason",
      header: LABELS.INCOMPLETION_REASON,
      cell: (e: any) => e.incompletionReason,
    },
  ];

  const columnDefinitionsBaseNotDocomo = [
    {
      id: "store_name",
      header: LABELS.STORE_NAME,
      cell: (e: any) => e.name,
    },
    { id: "address", header: LABELS.ADDRESS, cell: (e: any) => e.address },
    {
      id: "updateDifferencial",
      header: LABELS.APPLICATION_TYPE,
      cell: (e: any) => e.updateDifferencial,
    },
    {
      id: "application_status",
      header: LABELS.APPLICATION_STATUS,
      cell: (e: any) =>
        convertValueToLabel(e.applicationStatusCode, props.appStatusCodes),
    },
    {
      id: "fixedTime",
      header: LABELS.ANSWER_START_TIME,
      cell: (e: any) =>
        e.fixedTime === null || e.fixedTime === ""
          ? COMMON_LABELS.HYPHEN
          : formatDateTime(e.fixedTime),
    },
    {
      id: "incompletionReason",
      header: LABELS.INCOMPLETION_REASON,
      cell: (e: any) => e.incompletionReason,
    },
  ];

  const columnDefinitions = props.isDocomoUser
    ? columnDefinitionsBase
    : columnDefinitionsBaseNotDocomo;

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      loading={props.isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      trackBy="id"
      items={props.stores}
      resizableColumns
      stickyHeader
      header={
        <SpaceBetween size="xs">
          <SpaceBetween direction="horizontal" size="l"></SpaceBetween>
        </SpaceBetween>
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;
